//import '../../scss/master.scss';

import JQuery from 'jquery';
import '../../lib/jquery.extendable.js';
import 'nvsAccessTool';

import { Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Thumbs } from 'swiper/modules';
import Swiper from 'swiper';
Swiper.use([Navigation, Pagination, Scrollbar, Autoplay, EffectFade, Thumbs ]);
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

import Headroom from "headroom.js";
import VuduGdprPlugin from "./vudu-gdpr.js";
import "@lottiefiles/lottie-player";


/**
 * Header
*/

function initHamburgerNav() {
    const hambiBtn = document.querySelector(".site-header__hambi");
    const hambiNav = document.querySelector(".hambi-nav");
    const closeBtn = document.querySelector(".hambi-nav__close-btn");

    if (!hambiBtn || !hambiNav || !closeBtn) return;

    // open hamburger nav
    hambiBtn.addEventListener("click", () => {
        hambiNav.classList.add("is-active");
        // close search
        document.querySelector(".js-toggle-search").classList.remove("search-open");
        document.querySelector(".js-search-overlay").classList.remove("open");

    });

    // close hamburger nav (and all open subnavs)
    closeBtn.addEventListener("click", () => {
        hambiNav.classList.remove("is-active");
        hambiNav.querySelectorAll(".hambi-nav__dropdown--sub.is-active").forEach(sub => {
            sub.classList.remove("is-active");
        });
    });

    // open subnav on item button click
    hambiNav.querySelectorAll(".hambi-nav__menu-item-btn").forEach(btn => {
        btn.addEventListener("click", () => {
            const subDropdown = btn.nextElementSibling;
            if (subDropdown && subDropdown.classList.contains("hambi-nav__dropdown--sub")) {
                subDropdown.classList.add("is-active");
            }
        });
    });

    // back button inside subnav
    hambiNav.querySelectorAll(".hambi-nav__sub-header-btn").forEach(btn => {
        btn.addEventListener("click", () => {
            const parentDropdown = btn.closest(".hambi-nav__dropdown--sub");
            if (parentDropdown) {
                parentDropdown.classList.remove("is-active");
            }
        });
    });
}

//overlay search
function closeSearch() {
	if($(".js-search-overlay").hasClass("open")) {
		$("body").removeClass("hideOverflow");
		$(".js-search-overlay").removeClass("open");
		$(".nav__link").removeClass("search-open");
		$(".c-link").removeClass("search-open");
		$(".js-toggle-search").removeClass("search-open");
	}	
}

function closeSearchBtn() {
	$(".js-search-close").click(function (e) {
		$("body").removeClass("hideOverflow");
		$(".js-search-overlay").removeClass("open");
		$(".nav__link").removeClass("search-open");
		$(".c-link").removeClass("search-open");
		$(".js-toggle-search").removeClass("search-open");
	})
}

function searchNav() {
	$(".js-toggle-search").click(function (e) {
		if ($(".nav__btn-toggle").attr('data-mob-nav') == 'on') {
			$(".nav__btn-toggle").attr('data-mob-nav', 'off');
			removeNavItemClasses();
		}
		if ( $(".nav").hasClass("menu-open") ) {
			$(".nav").removeClass("menu-open");
		}
		e.preventDefault();
		if($(".js-search-overlay").hasClass("open")) {
			$("body").removeClass("hideOverflow");
			$(".js-search-overlay").removeClass("open");
			$(".nav__link").removeClass("search-open");
			$(".c-link").removeClass("search-open");
			$(".js-toggle-search").removeClass("search-open");
		}
		else {
			$("body").addClass("hideOverflow");
			$(".js-search-overlay").addClass("open");
			$(".nav__link").addClass("search-open");
			$(".c-link").addClass("search-open");
			$(".js-toggle-search").addClass("search-open");
			$(".search-block-nav__input").focus();
		}
	});

}

var headerElement = document.querySelector(".site-header");
var headroom  = new Headroom(headerElement, {
	offset : 0,
    // or you can specify offset individually for up/down scroll
    offset: {
        up: 100,
        down: 50
    },
    // scroll tolerance in px before state changes
    tolerance : 0,
    // or you can specify tolerance individually for up/down scroll
    tolerance : {
        up : 5,
        down : 0
    },
    // css classes to apply
    classes : {
        // when element is initialised
        initial : "site-header",
        // when scrolling up
       // pinned : "is-fixed",
        // when scrolling down
       // unpinned : "is-not-pinned",
        // when above offset
        //top : "headroom--top",
        // when below offset
        notTop : "is-offset",
        // when at bottom of scroll area
        //bottom : "headroom--bottom",
        // when not at bottom of scroll area
        //notBottom : "headroom--not-bottom",
        // when frozen method has been called
        //frozen: "headroom--frozen",
        // multiple classes are also supported with a space-separated list
        //pinned: ""
    },
});


/**
 * Functionality
*/

// rjesenja filter
function rjesenjaFilter() {
	let scrollTopEl= $('div.filter-wrap--solutions div.filter__heading')[0];

	let $section= $('section.solutions-block');
	let $blocks= $section.find('div.solutions-block__wrap');

	let $els= $("ul.filter__list>li.filter__item>input");
	let $lbls= $els.siblings('label');
	let $clearSec =  $(".filter-wrap--solutions .js-clear-item");
	$lbls.on('click', function(e){
		let $this=$(this);
		//toggle checkboxes
		$els.attr('checked', false);
		$this.siblings('input').attr('checked', true);

		//filter by id
		let id= $this.attr('for').substring( 'checkbox-'.length );
		if( id== 'all'){
			$blocks.show();
		}else{
			$blocks.hide();
			$blocks.filter(`[data-id-content=${id}]`).show();
		}
		scrollTopEl.scrollIntoView(true);

	});
}

// filter toggle mobile only 
function filterToggle() {

    if ($(window).width() < 992) {

        $(".js-filter-open").click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            $(this).parent().next().addClass("is-open");
			$("body").attr("data-overflow", "off");
        });

		$(".js-filter-close").click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            $(this).parent().removeClass("is-open");
			$("body").attr("data-overflow", "on");
        });
    }
}

//news filter select and delete
var filterSelect = function() {
	$(".js-filter").each(function(index, item){

		$(this).on('click touchstart', function(e) {
			e.stopPropagation();
		});

		var $el = $(this);
		var checked_items = $el.find('.filter__item input[type="radio"]');

		changeHandle();
		clearFilterItem($el);

		checked_items.on("change", changeHandle);

		function changeHandle(e){

			$el.find('.filter__item input[type="radio"]').each( function(index){


				if ($(this).is(":checked")){

					let value = $(this).siblings(".checkbox-label").html();
					let filterData = $(this).attr("data-filterid");
					$el.find('.filter__selected-items').html('<div class="filter__selected-item filter__selected-item--' + filterData + '"><a href="#" class="clear js-clear-item" data-filterorigin="' + filterData + '"></a><span>' + value + '</span></div>');
					closePopout();

					let $section= $('section.solutions-block');
					let $blocks= $section.find('div.solutions-block__wrap');
					//let $sectionSelected= $blocks.find(`[data-id-content='${filterData}']`)
					//console.log(filterData);
					//console.log($sectionSelected);

					if(filterData == 'all'){
						$blocks.show();
					} else {
						$blocks.hide();
						$blocks.filter(`[data-id-content=${filterData}]`).show();
					}

					if ($(this).length == 0)  {
						$el.find(".filter__selected").removeClass("is-open");
						
					} else {
						clearFilterItem($el);
						$el.find(".filter__selected").addClass("is-open");
					};
				}
			});
		};

		function closePopout() {
			$("body").attr("data-overflow", "on");
			$(".filter__wrap").removeClass("is-open");
		}

		function clearFilterItem($el) {
			$(".js-clear-item").on('click tap touchstart', function(e){
				e.preventDefault();

				var indexdataValue = $(this).attr("data-filterorigin");

				$el.find('.filter__item input[type="radio"]').each( function(index){
					let indexdataCheck = $(this).attr("data-filterid");

					if(indexdataCheck == indexdataValue) {
						$(this).prop('checked', false);
					}
				});

				$(e.target).parent().remove();

				$el.find(".filter__selected").removeClass("is-open");

				let $section= $('section.solutions-block');
				let $blocks= $section.find('div.solutions-block__wrap');
				$blocks.show();
			});
		}
	});
};

//nabava select content from sidebar link
var nabavaSelectContent = function() {

	$(".js-content").on('click', function(e) {
		e.preventDefault();
		$(".js-content").removeClass("is-active");
		$(this).addClass("is-active");

		let linkData = $(this).attr("data-id");


		$(".js-content-wrap").find('.download__section').each( function(index){

			let contentData = $(this).attr("data-id-content");

			if(contentData == linkData) {
				$(this).addClass("is-open");
			} else {
				$(this).removeClass("is-open");
			}
		});
	});
};

//faq func
var makeAccordion = function () {
	// Wrap each <h2> and its next element only if not already inside .accordion-wrap
	$(".l-article h2").each(function () {
		const $h2 = $(this);

		// Skip if already wrapped
		if ($h2.closest(".accordion-wrap").length) return;

		const $next = $h2.next();
		if ($next.is("ul") || $next.is("div.accordion-c")) {
			$h2.add($next).wrapAll('<div class="accordion-wrap js-accordion" />');
		}
	});

	// Add download class to links
	$(".accordion-wrap li a").addClass("download-btn");

	// Show first, hide others
	$(".js-accordion").each(function (index) {
		const $h2 = $(this).find("h2");
		const $target = $h2.next();

		if (index === 0) {
			$(this).addClass("is-open");
			$h2.addClass("js-accordion--open");
			//$target.show();
		} else {
			//$target.hide();
		}
	});

	$(".js-accordion h2").click(function () {
		const $this = $(this);
		const $target = $this.next();
		const isOpen = $this.hasClass("js-accordion--open");

		// Close all
		$(".js-accordion h2").removeClass("js-accordion--open");
		$(".js-accordion").removeClass("is-open");
		$(".js-accordion").each(function () {
			$(this).find("h2").next().slideUp();
		});

		// Open this one if it wasn't open
		if (!isOpen) {
			$this.addClass("js-accordion--open");
			$this.parent().addClass("is-open");
			$target.slideDown();
		}
		// On mobile scroll to top of open element
		if (window.innerWidth < 992) {
			console.log("mobile faq");
			$('html, body').animate({
				scrollTop: $this.offset().top - 80
			}, 1000);
		}

	});
};

//responsive sidebar master article
function responsiveSidebar()  {

	if ($(".hero").length  &&  $(".sidebar").length  &&  window.innerWidth < 992) {

		$('.sidebar').insertBefore('.hero .hero__title');

		if ($(".hero .breadcrumbs").length ) {
			$(".hero").addClass("hero--sidebar-b");
		} else {
			$(".hero").addClass("hero--sidebar");
		}
	}
};

function responsiveSidebarInit()  {

	if ($(".hero").length  &&  $(".sidebar").length  &&  window.innerWidth > 991) {

		$('.sidebar').appendTo('.master-article-content .col-lg-3');
	}
};

//scroll on active sidebar item, mobile only
function activeCategoryScroll() {
    var sidebarWrap = document.querySelector('.sidebar__list');

    if (sidebarWrap && $(window).width() < 993) {
        var activeLink = sidebarWrap.querySelector('.sidebar__link.is-active');

		if (activeLink) {
            var linkPosition = activeLink.getBoundingClientRect();
            var wrapPosition = sidebarWrap.getBoundingClientRect();

			if (linkPosition.left < wrapPosition.left || linkPosition.right > wrapPosition.right) {
                sidebarWrap.scrollLeft = activeLink.offsetLeft - sidebarWrap.offsetLeft;
            }
        }
    }
}


/**
 * Swipers
*/

//product-single
const swiperProductGalleryThumbs = new Swiper('.x-swiper-product-gallery-thumbs', {
	freeMode: true,
	speed: 500,
	watchSlidesProgress: true,
	spaceBetween: 0,
	slidesPerView: 'auto',

	breakpoints: {
		320: {
			slidesPerView: 'auto',
		},
	},
});
const swiperProductGallery = new Swiper('.x-swiper-product-gallery', {
	spaceBetween: 16,
	//allowTouchMove: false,
	thumbs: {
		swiper: swiperProductGalleryThumbs,
	},
	pagination: {
		el: '.article-swiper__pagination',
		type: 'bullets',
		clickable: true,
	},
	navigation: {
		nextEl: '.article-swiper__button-next',
		prevEl: '.article-swiper__button-prev',
	},
});

//timeline-block
const swiperTimeline = new Swiper('.x-swiper-timeline', {
	init: false,
	loop: false,
	autoplay: false,
	slidesPerView: "auto",
	spaceBetween: 12,
	speed: 500,

	breakpoints: {
		991: {
		  spaceBetween: 30,
		}
	},

	navigation: {
		nextEl: '.timeline-list__button-next',
		prevEl: '.timeline-list__button-prev',
	},
});

var sectionNavSlider = {

	element: '.x-swiper-sidebar',
	firstLoad: true,
	swiperContent: undefined,
	map: [],
	tabs: [],

	init: function () {
		var self = this;

		var swiperContainer = $('.x-swiper-sidebar .swiper-container');
		var swiperWrapper = $('.x-swiper-sidebar .swiper-wrapper');

 		if ($(window).width() < 992) {
		this.initSelector();
		} else {
			self.swiperContent.destroy(true, true);
		}

		/*if ($('.x-swiper-sidebar .swiper-container').length === 0) {

			if (self.swiperContent) {
				self.swiperContent.destroy(true, true);
				$(".x-swiper-sidebar .swiper-container").removeClass("is-active");
			}
			return;
		}*/
	},

	initSelector: function () {
		var self = this;
		var initialIndex;
		var trackingIndex;

		$(".x-swiper-sidebar .swiper-container").addClass("is-active");

		self.swiperContent = new Swiper('.x-swiper-sidebar .swiper-container', {
			slidesPerView: 'auto',
			spaceBetween: 0,
			speed: 850,
			loop: false,
			autoplay: false,

			on: {
				init: function (swiper) {

					function getSlideIndexByClass(className) {
						var index = 0;
						$.each($('.x-swiper-sidebar .swiper-wrapper').children(), function (i, item) {
							if ($(item).hasClass(className)) {
								index = i;
								return false;
							}
						});
						return index;
					}

					this.slideTo(getSlideIndexByClass('swiper-slide-active'));
				},
			}
		});
	},
};


/**
 * Animation
*/

var stickyFaqMenu = {

	controller: null,
	scenes: {},


	init: function() {

		if ($(".sidebar").length) {

			// Init controller
			stickyFaqMenu.controller = new ScrollMagic.Controller({globalSceneOptions: {triggerHook: 0} });

			// Targeting sections with fixed sidebar and creating scenes from those sections
			$(".sidebar").each(function(index, item){

				var self = this;

				//console.log("self height", $(self).height())
				let DurationFaq = $(".master-article-content").height();

				var sceneobj = new ScrollMagic.Scene({
					triggerElement: ".sidebar",
					//duration: function(){
					//	return $(self).height();
					//}
					duration: DurationFaq,
				})

				.on("enter", function (event) {
					$(".sidebar__inner").addClass("is-sticky");
				})

				.on("leave", function (event) {
					$(".sidebar__inner").removeClass("is-sticky");
				})
				.addTo(stickyFaqMenu.controller);

			});
		}
	},
};


/**
 * on dom ready
 * Fires when the HTML document has been completely loaded and parsed (DOM tree built).
 */

$(document).ready(function(){

	headroom.init();
	VuduGdprPlugin.init();
	swiperProductGallery.init();
	swiperTimeline.init();
	initHamburgerNav();
	nabavaSelectContent();
	makeAccordion();
	searchNav();
	closeSearchBtn();

	$(".external").click(function(e) {
        e.preventDefault();
        window.open(this.href);
    });

	setTimeout(function(){
		activeCategoryScroll();
	}, 100);
});


/**
 * Other events
 */

$(document).keydown(function (event) {
	if (event.keyCode == 27) {
		closeSearch();
	}
});


var mqm = window.matchMedia("(max-width: 991px)");

function checkMediaWidthm(mqm) {
	if (mqm.matches) {

		filterToggle();
		filterSelect();
		stickyFaqMenu.init();
		responsiveSidebar();

	} else {
		responsiveSidebarInit();
		rjesenjaFilter();
	}
}

mqm.addEventListener('change',checkMediaWidthm);
checkMediaWidthm(mqm);
